import Axios from 'axios'  
import store from '../store'
// import {Auth} from 'aws-amplify'
import {API} from "aws-amplify";
import { Auth } from 'aws-amplify'



// const BASE_URL = "https://yorwdi486f.execute-api.eu-west-1.amazonaws.com/dev"
const TABLE_NAME = "ipman_dev"
const ENDPOINT_NAME = "ipman"


export default {
    getAllNetworks() {

        this.checkUserLoggedIn()

        let jwtToken = store.getters['authstore/userIdJwtToken']

        let myInit = { // OPTIONAL
            queryStringParameters: {  // OPTIONAL
                TableName:TABLE_NAME
            },
            headers:{
                'Authorization': 'Bearer '+jwtToken,
            },
        }

        return API.get(ENDPOINT_NAME, "/networks", myInit)
    },
 
    getNetwork(guid) {

        this.checkUserLoggedIn()

        let jwtToken = store.getters['authstore/userIdJwtToken']

        let myInit = { // OPTIONAL
            queryStringParameters: {  // OPTIONAL
                TableName:TABLE_NAME
            },
            headers:{
                'Authorization': 'Bearer '+jwtToken
            },
        }
        return API.get(ENDPOINT_NAME, "/networks/"+guid, myInit)
    },
    
    create(data) {

        this.checkUserLoggedIn()

        return Axios.post(RESOURCE_NAME, data)
    },
    
    updateNetwork(guid, data) {

        this.checkUserLoggedIn()

        let jwtToken = store.getters['authstore/userIdJwtToken']

        let myInit = { 
            body: data,
            headers:{
                'Authorization': 'Bearer '+jwtToken
            },
            response: true, // (return the entire Axios response object instead of only response.data)
        }
        return API.put(ENDPOINT_NAME, "/networks/"+guid, myInit)
    },
    createNetwork(data) {

        this.checkUserLoggedIn()

        let jwtToken = store.getters['authstore/userIdJwtToken']
           
        let myInit = { //
            body: data,
            headers:{
                'Authorization': 'Bearer '+jwtToken
            },
            response: true, // (return the entire Axios response object instead of only response.data)
        }
        return API.post(ENDPOINT_NAME, "/networks", myInit)
    },
    deleteNetwork(guid) {

        this.checkUserLoggedIn()

        let jwtToken = store.getters['authstore/userIdJwtToken']

        let myInit = { // OPTIONAL
            headers:{
                'Authorization': 'Bearer '+jwtToken
            },
            response: true,
        }
        return API.del(ENDPOINT_NAME, "/networks/"+guid, myInit)

    },
    checkUserLoggedIn(){
        Auth.currentAuthenticatedUser({ bypassCache: true })
        .then(data => {
            if (data && data.signInUserSession) {
                return
            } else {
                window.location.href = '/auth'
            }
        })
        .catch((e) => {
            window.location.href = '/auth'
        })
    },
}